<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-switch v-model="isValid" :label="title" class="v-input--reverse" />
    </v-flex>
    <v-flex v-if="isValid" xs10 offset-xs1>
      <div v-if="isError" class="red--text">
        下限を上限よりも小さくしてください。
      </div>
      <v-layout>
        <v-flex xs1>
          <v-select
            :items="minArray"
            v-model="minVal"
            :item-text="'name'"
            :item-value="'value'"
            dense
            style="padding-top: 0px;"
          />
        </v-flex>
        <v-flex align-self-center xs1>
          <p align="center">〜</p>
        </v-flex>
        <v-flex xs1>
          <v-select
            :items="maxArray"
            v-model="maxVal"
            :item-text="'name'"
            :item-value="'value'"
            dense
            style="padding-top: 0px;"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'CampaignModalPageOfficeSelectCondition',
  props: {
    title: {
      type: String,
      default: '',
    },
    minArray: {
      type: Array,
      default: () => [],
    },
    maxArray: {
      type: Array,
      default: () => [],
    },
    minInitialVal: {
      type: Number,
      default: 0,
    },
    maxInitialVal: {
      type: Number,
      default: null,
    },
    isValidInitialVal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      minVal: this.minInitialVal,
      maxVal: this.maxInitialVal,
      isValid: this.isValidInitialVal,
    }
  },
  computed: {
    isError() {
      if (this.isValid) {
        if (this.maxVal === null) {
          return false
        }
        if (this.minVal >= this.maxVal) {
          return true
        }
      }
      return false
    },
  },
  watch: {
    minVal: {
      handler(value) {
        this.$emit('onChangeMinVal', value)
      },
    },
    maxVal: {
      handler(value) {
        this.$emit('onChangeMaxVal', value)
      },
    },
    isValid: {
      handler(value) {
        this.$emit('onChangeIsValid', value)
      },
    },
  },
  methods: {
    validate() {
      return !this.isError
    },
  },
}
</script>

<style scoped lang="scss">
.v-input--reverse {
  ::v-deep .v-input__slot {
    flex-direction: row-reverse;
    .v-input--selection-controls__input {
      margin-left: 8px;
    }
  }
}
</style>
